var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-90 0 27)",
    fill: "#EDF2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.0002C11.6333 18.0002 11.3196 17.8697 11.0587 17.6088C10.7973 17.3475 10.6667 17.0335 10.6667 16.6668V8.66683C10.6667 8.30016 10.7973 7.98616 11.0587 7.72483C11.3196 7.46394 11.6333 7.3335 12 7.3335H18C18.3667 7.3335 18.6807 7.46394 18.942 7.72483C19.2029 7.98616 19.3333 8.30016 19.3333 8.66683V16.6668C19.3333 17.0335 19.2029 17.3475 18.942 17.6088C18.6807 17.8697 18.3667 18.0002 18 18.0002H12ZM9.33333 20.6668C8.96667 20.6668 8.65267 20.5364 8.39133 20.2755C8.13044 20.0142 8 19.7002 8 19.3335V10.6668C8 10.4779 8.064 10.3195 8.192 10.1915C8.31956 10.0639 8.47778 10.0002 8.66667 10.0002C8.85556 10.0002 9.014 10.0639 9.142 10.1915C9.26956 10.3195 9.33333 10.4779 9.33333 10.6668V19.3335H16C16.1889 19.3335 16.3473 19.3975 16.4753 19.5255C16.6029 19.6531 16.6667 19.8113 16.6667 20.0002C16.6667 20.1891 16.6029 20.3473 16.4753 20.4748C16.3473 20.6028 16.1889 20.6668 16 20.6668H9.33333Z",
    fill: "#A2AD1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.be1c42bf4d7a96569aa483437c8075ec.svg";
export { ForwardRef as ReactComponent };